<mat-form-field *ngIf="!disabled">
  <mat-label>{{placeholder}}</mat-label>
    <input matInput [formControl]="childControl" [required]="required"
           (ngModelChange)="updateNgModel($event);" [(ngModel)]="childValue" [matAutocomplete]="autoArticles">
    <button type="button" matSuffix mat-icon-button (click)="childValue = null; value = null;">
        <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete #autoArticles="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngFor="let res of listResults" [value]="res" [ngStyle]="{'line-height': 'normal', 'height': !hideCode ? '72px' : 'inherit'}">
          <ng-container *ngIf="!hideCode">{{res.Code }}<br></ng-container>
          {{res.DisplayName}}<br>
          {{res.OptionWeight}}{{res.Unit?.Value}} x{{res.Step}} {{res.Packaging?.Value}}
        </mat-option>
    </mat-autocomplete>
  <mat-hint *ngIf="childValue">{{childValue.Parent ? childValue.Parent.DisplayName : childValue.DisplayName}} {{childValue.Step}}x {{childValue.OptionWeight}}{{childValue.Unit?.Value}}
  </mat-hint>
</mat-form-field>
<mat-form-field *ngIf="disabled">
  <mat-label>{{placeholder}}</mat-label>
    <input matInput [required]="required" [disabled]="true"
           [value]="childValue?.Code">
  <mat-hint *ngIf="childValue">{{childValue.Parent ? childValue.Parent.DisplayName : childValue.DisplayName}} {{childValue.Step}}x {{childValue.OptionWeight}}{{childValue.Unit?.Value}}
  </mat-hint>
</mat-form-field>
